import { useQuery } from "@tanstack/react-query";
import { apiGet } from "../client";

/**
 * Hook to get job schedule
 */
export function useJobSchedule(
	startTime: string,
	endTime: string,
	customerIds?: string[],
	expand?: string[],
	include?: string[],
	onError?: (errorCode: string) => void,
) {
	if (!customerIds) {
		return { jobSchedules: [], isLoading: false };
	}

	const { data, ...res } = useQuery<any>({
		queryKey: ["useJobSchedule", startTime, endTime, JSON.stringify(customerIds)],
		queryFn: () =>
			apiGet<any>("/schedule/job", {
				startTime,
				endTime,
				customerIds: customerIds ? customerIds.join(",") : "",
				expand: expand ? expand.join(",") : "",
				include: include ? include.join(",") : "",
			}),
		onError: (error: any) => {
			const errorCode = error?.response?.data?.code || error?.message || "UNKNOWN_ERROR";
			if (onError) {
				onError(errorCode);
			}
		},
	});

	return { ...data, ...res };
}

/**
 * Hook to get consultant schedule
 */
export function useConsultantSchedule(
	startTime: string,
	endTime: string,
	customerIds?: string[],
	expand?: string[],
	include?: string[],
	onError?: (errorCode: string) => void,
) {
	if (!customerIds) {
		return { consultantSchedules: [], isLoading: false };
	}

	const { data, ...res } = useQuery<any>({
		queryKey: [
			"useConsultantSchedule",
			startTime,
			endTime,
			JSON.stringify(customerIds),
			JSON.stringify(expand),
			JSON.stringify(include),
		],
		queryFn: () =>
			apiGet<any>("/schedule/consultant", {
				startTime,
				endTime,
				customerIds: customerIds ? customerIds.join(",") : "",
				expand: expand ? expand.join(",") : "",
				include: include ? include.join(",") : "",
			}),
		onError: (error: any) => {
			const errorCode = error?.response?.data?.code || error?.message || "UNKNOWN_ERROR";
			if (onError) {
				onError(errorCode);
			}
		},
	});

	return { ...data, ...res };
}
